// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"date-range-tabs_wrapper__653oR","tabsWrapper":"date-range-tabs_tabsWrapper__3rstF","dateWrapper":"date-range-tabs_dateWrapper__ecHD5"};